import { memo, PropsWithChildren } from 'react';
import { useCarouselContext } from '../carousel.context';

type TrackProps = {
  style?: React.CSSProperties;
  className?: string;
};

export const Track = memo(
  ({ style, className, children }: PropsWithChildren<TrackProps>) => {
    const { total, trackStyle } = useCarouselContext();

    return (
      <div
        style={{
          display: 'flex',
          width: `${total * 100}%`,
          height: '100%',
          willChange: 'transform',
          ...trackStyle,
          ...style,
        }}
        className={className}
      >
        {children}
      </div>
    );
  }
);

Track.displayName = 'Carousel.Track';
